// Ideally, `SelectOption` should extend `OptionType` provided by `@atlaskit/select`, but
// `OptionType` has a property `[key: string]: any;`, which opens the door for broken code - using
// properties that are not defined.

export const toSelectOption = choice => {
  return {
    value: choice.id,
    label: choice.label
  };
};